import _createClass from '@babel/runtime/helpers/esm/createClass';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _isNativeReflectConstruct from '@babel/runtime/helpers/esm/isNativeReflectConstruct';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _wrapNativeSuper from '@babel/runtime/helpers/esm/wrapNativeSuper';

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
var ReconcileApiExceptionType = /*#__PURE__*/function (ReconcileApiExceptionType) {
  ReconcileApiExceptionType["EmailAlreadyUsed"] = "https://api.landr.com/errors/EmailAlreadyUsed";
  return ReconcileApiExceptionType;
}({});
var AuthServiceCustomErrors = /*#__PURE__*/function (AuthServiceCustomErrors) {
  AuthServiceCustomErrors["ReconcileError"] = "reconcile_error";
  AuthServiceCustomErrors["CodeAndStateValidationError"] = "code_and_state_validation_error";
  AuthServiceCustomErrors["EmailAlreadyUsedError"] = "email_already_used_error";
  AuthServiceCustomErrors["AccessTokenRequestError"] = "access_token_request_error";
  return AuthServiceCustomErrors;
}({});
var OAuthError = /*#__PURE__*/function (_Error) {
  function OAuthError(message, errorCode) {
    var _this;
    _classCallCheck(this, OAuthError);
    _this = _callSuper(this, OAuthError, [message]);
    _this.errorCode = errorCode;
    return _this;
  }
  _inherits(OAuthError, _Error);
  return _createClass(OAuthError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { AuthServiceCustomErrors, OAuthError, ReconcileApiExceptionType };
